import request from "../Config/axios";
// -----------------------------------------------------------
export const GetAll_Paging_FoodPricePeriod_Api = async (params) => {
    const { data } = await request.post(
        `/FoodPricePeriod/GetAll_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Add_FoodPricePeriod_Api = async (params) => {
    const { data } = await request.post(
        `/FoodPricePeriod/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_FoodPricePeriod_Api = async (id) => {
    const { data } = await request.get(
        `/FoodPricePeriod/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_FoodPricePeriod_Api = async (params) => {
    const { data } = await request.post(
        `/FoodPricePeriod/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_FoodPricePeriod_Api = async (id) => {
    const { data } = await request.delete(
        `/FoodPricePeriod/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
